/*
 * Copyright (c) 2016 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.slider

import com.macrofocus.common.properties.MutableProperty
import org.mkui.component.CPComponent

/**
 * Created by luc on 25/05/16.
 */
interface RangeSliderView : CPComponent {
    fun setModel(model: RangeSliderModel?)
    val orientation: MutableProperty<Orientation>
    val continuousUpdating: MutableProperty<Boolean>

    enum class PropertyType {
        Orientation, ColorTheme, ContinuousUpdating
    }

    enum class Orientation {
        Horizontal, Vertical
    }
}